class OperationalAreaService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/operational-area', params);
  }

  getById(id) {
    return this.apiService.get(`/api/v1/avg/operational-area/${id}`);
  }

  create(params) {
    return this.apiService.post('/api/v1/avg/operational-area', params);
  }

  update(params) {
    return this.apiService.put(`/api/v1/avg/operational-area/${params.id}`, params);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/avg/operational-area', params);
  }
}

export default OperationalAreaService;
